import { Package } from '../models/package';
import { emptyCommodity } from './empty-commodity';
import { PackagingTypeEnum } from '../enum/packaging-type.enum';
import { CurrencyEnum } from '../enum/currency.enum';

export const emptyPackage: Package = {
    id: null,
    description: '',
    quantity: 1,
    weight: 1,
    width: 1,
    height: 1,
    length: 1,
    value: 0,
    stackable: false,
    packageCode: null,
    freightClass: null,
    nmfcNumber: null,
    hazmatClass: null,
    unNumber: null,
    commodities: [],
    weightUnit: null,
    dimensionUnit: null,
    trackingNumber: null,
    currency: CurrencyEnum.USD,
    dimensionalWeight: null,
    declaredWeight: null,
    declaredWidth: null,
    declaredHeight: null,
    declaredLength: null,
    billingWeight: null,
    billingWidth: null,
    billingHeight: null,
    billingLength: null,
    packagingType: PackagingTypeEnum.CUSTOMER_PACKAGING,
    templateId: null,
    boxPacking: null
};
